/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { Address } from '@msdyn365-commerce/retail-proxy';
import * as React from 'react';

export interface IDeliveryOptionAddressProps {
    deliveryAddress?: Address;
}

/**
 * @param root0
 * @param root0.deliveryAddress
 * @extends {React.FC<IDeliveryOptionAddressProps>}
 */
const DeliveryOptionAddress: React.FC<IDeliveryOptionAddressProps> = ({ deliveryAddress }) => {
    if (!deliveryAddress) {
        return null;
    }
    /* eslint-disable prettier/prettier */
    return (
        <span>
            {deliveryAddress?.Name} {deliveryAddress?.City} {deliveryAddress?.Street} {deliveryAddress?.ZipCode}
        </span>
    );
};

export default DeliveryOptionAddress;
